<template>
  <div class="share-box" id="share">
    <div class="mask"></div>
    <div class="mask mask2"></div>
    <div class="s-con">
      <div class="title"> <i class="fa fa-gift"></i> {{ $t('share.p1') }}</div>
      <div class="m-r">{{ $t('share.p2') }} <span class="gold-text">{{ $t('share.p3') }}</span></div>
      <div class="des">{{ $t('share.p4') }}</div>
      <div class="in-box">
        <div class="i-b-i">
          <div class="b-1">
            <div class="b-1-c"><i class="fa fa-users"></i></div>
            <div class="b-1-r">
              <div class="t1">{{ $t('share.p5') }}</div>
              <div class="t2">{{ $t('share.p6') }}</div>
            </div>
          </div>
          <div class="b-2">
            <div class="b-2-1"> <span class="num">20%</span>{{ $t('share.p7') }}</div>
            <div class="b-2-2">{{ $t('share.p8') }} <span>160 USDC</span></div>
          </div>
        </div>
        <div class="i-b-i i-b-i2">
          <div class="b-1">
            <div class="b-1-c"><i class="el-icon-s-operation"></i></div>
            <div class="b-1-r">
              <div class="t1">{{ $t('share.p9') }}</div>
              <div class="t2">{{ $t('share.p10') }}</div>
            </div>
          </div>
          <div class="b-2">
            <div class="b-2-1"> <span class="num">10%</span>{{ $t('share.p11') }}</div>
            <div class="b-2-2">{{ $t('share.p12') }} <span>80 USDC</span></div>
          </div>
        </div>
      </div>
      <div class="case">
        <div class="c-t">{{ $t('share.p13') }}</div>
        <div class="t-r t-h">
          <div class="c-i">{{ $t('share.p14') }}</div>
          <div class="c-i c-2">{{ $t('share.p15') }}</div>
          <div class="c-i c-3">{{ $t('share.p16') }}</div>
        </div>
        <div class="t-r t-r-1">
          <div class="c-i c-1"><span class="c-i-t">{{ $t('share.p17') }}</span><br><span class="c-i-s">{{ $t('share.p18') }}</span></div>
          <div class="c-i c-2">160 USDC (20%)</div>
          <div class="c-i c-3">-</div>
        </div>
        <div class="t-r">
          <div class="c-i c-1"><span class="c-i-t">{{ $t('share.p19') }}</span><br><span class="c-i-s">{{ $t('share.p20') }}</span></div>
          <div class="c-i c-2">160 USDC (20%)</div>
          <div class="c-i c-3 c-blue">80 USDC (10%)</div>
        </div>
      </div>
      <div class="s-box">
        <div class="s-b-t"><i class="el-icon-share"></i> {{ $t('share.p21') }}</div>
        <template v-if="walletAddress">
          <div class="l-b">
            <div class="l-b-l">{{ linkUrl }}</div>
            <div class="l-b-r" v-clipboard:copy="linkUrl" v-clipboard:success="onCopy" v-clipboard:error="onError"><i
                class="el-icon-document-copy"></i></div>
          </div>
          <div class="s-b-b">{{ $t('share.p22') }}</div>
        </template>
        <div class="btn-box" v-else>
          <div class="btn">{{ $t('share.p23') }}</div>
        </div>
      </div>
      <div class="list-box">
        <div class="item">
          <div class="i-c">
            <i class="el-icon-check"></i>
          </div>
          <div class="t1">{{ $t('share.p24') }}</div>
          <div class="t2">{{ $t('share.p25') }}</div>
        </div>
        <div class="item">
          <div class="i-c">
            <i class="el-icon-check"></i>
          </div>
          <div class="t1">{{ $t('share.p26') }}</div>
          <div class="t2">{{ $t('share.p27') }}</div>
        </div>
        <div class="item">
          <div class="i-c">
            <i class="el-icon-check"></i>
          </div>
          <div class="t1">{{ $t('share.p28') }}</div>
          <div class="t2">{{ $t('share.p29') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'Share',
  data() {
    return {
      linkUrl: ''
    }
  },
  computed: {
    ...mapState(['walletAddress'])
  },
  watch: {
    walletAddress(newVal) {
      if(newVal) this.getLinkUrl()
    }
  },
  methods: {
    getLinkUrl() {
      let href = window.location.href;
      let link = ''
      if(window.location.href.includes('?utm_source=tokenpocket')) {
        let strArr = href.split('?utm_source=tokenpocket')
        link = strArr[0]
      }else if(window.location.href.includes('?inviterAddress%')) {
        let strArr = href.split('?inviterAddress%')
        link = strArr[0]
      } else if (window.location.href.includes('inviterAddress')) {
        let strArr = href.split('?inviterAddress=')
        link = strArr[0]
      } else {
        link = href
      }
      console.log('this.walletAddress', this.walletAddress)
      this.linkUrl = link + '?inviterAddress=' + this.walletAddress
    },
    onCopy(e) {
      this.$message({
        message: '复制成功',
        type: 'success',
        duration: 1000
      });
    },
    onError(e) {
      this.$message({
        message: '复制失败，请稍后再试',
        type: 'error',
        duration: 1000
      });
    },
  }
}
</script>

<style scoped lang="scss">
@import './style.scss';
@import './h5-style.scss';
</style>
